<div class="volume-filter-wrapper" [ngClass]="variant" #filterContainer>
    <ng-container *ngIf="variant === 'header'">
        <div class="filter-button" [ngClass]="{'open': isOpen, 'active': isActive}" (click)="openFilter()"
            data-testid="volume-filter-button"
            matTooltip="Hides low-volume segments so analysis focuses on larger contributors"
            matTooltipPosition="below">
            <img [src]="'svg/filters.svg' | assetVersion">
            <img *ngIf="isActive" class="active-indicator" [src]="'svg/Ellipse-94.svg' | assetVersion">
        </div>
    </ng-container>
    <ng-container *ngIf="variant === 'sidebar'">
        <div class="sidebar-button" [ngClass]="{'selected': isOpen}" (click)="openFilter()"
            data-testid="volume-filter-button">
            <span *ngIf="isActive" class="open-indicator"></span>
            <img [src]="'svg/Volume.svg' | assetVersion">
            <span>Volume</span>
        </div>
    </ng-container>
    <div *ngIf="isOpen" class="filter-popover" data-testid="volume-filter-popover">
        <div class="input-field">
            <label class="field-label">Filter by min impressions</label>
            <input
                type="text"
                class="field-input"
                data-testid="volume-filter-input"
                [ngClass]="{'error': errorMessage}"
                [(ngModel)]="inputValue"
                (ngModelChange)="onInputChange()"
                (keydown)="onKeydown($event)"
                placeholder="e.g. 5,000"
                autocomplete="off">
            <span *ngIf="errorMessage" class="error-message" data-testid="volume-filter-error">{{errorMessage}}</span>
        </div>
        <div class="button-group">
            <button class="btn-clear" data-testid="volume-filter-clear" [disabled]="isClearDisabled" (click)="clearFilter()">Clear filter</button>
            <button class="btn-apply" data-testid="volume-filter-apply" [disabled]="isApplyDisabled" (click)="applyFilter()">Apply</button>
        </div>
    </div>
</div>